import { useEffectOnce } from 'hook/useEffectOnce'
import { observer } from 'mobx-react-lite'
import { Doc } from 'page/Doc/Doc'
import { Fullscreen } from 'page/Fullscreen/Fullscreen'
import { Maxi } from 'page/Maxi'
import { MiniBar } from 'page/MiniBar/MiniBar'
import { MiniRound } from 'page/MiniRound/MiniRound'
import { None } from 'page/None/None'
import { ProfileBanner } from 'page/ProfileBanner'
import { useEffect } from 'react'
import { opt } from 'store/opt'
import { stand } from 'store/stand'
import { store } from 'store/store'
import css from './Main.module.scss'

export const Main = observer(() => {
  const { fullscreen, state, options, doc } = store
  const { collapse_button_type } = options ?? {}
  const icon = collapse_button_type === 'icon'
  const tiny = store.parentWidth <= 480
  const round = tiny || icon

  const width = opt.basic ? 1200 : opt.stand2 ? 768 : 640
  const header = opt.basic ? 0 : opt.stand2 ? stand.header : 56
  const footer = opt.footer ? opt.stand2 ? 64 : 40 : opt.basic ? 0 : opt.stand2 ? 24 : 16

  useEffect(() => {
    document.body.classList.toggle(css.stand!, opt.stand)
    document.body.style.setProperty('--max-width', width + 'px')
    document.body.style.setProperty('--header-height', header + 'px')
    document.body.style.setProperty('--footer', footer + 'px')
  }, [width, header, footer])

  useEffectOnce(() => () => {
    document.body.classList.remove(css.stand!)
    document.body.style.setProperty('--max-width', null)
    document.body.style.setProperty('--header-height', null)
    document.body.style.setProperty('--footer', null)
  })

  if (fullscreen) {
    return <div key="fullscreen" className={css.main}>
      <Fullscreen />
    </div>
  }

  return (
    <div key={state} className={css.main}>
      {state === 'none' && <None />}
      {state === 'min' && round && <MiniRound />}
      {state === 'min' && !round && <MiniBar />}
      {state === 'max' && <Maxi />}
      {state === 'max' && <ProfileBanner />}
      {doc && <Doc />}
    </div>
  )
})
